<template>
  <router-view />
</template>

<script>
export default {
  name: "BracketsPage",
  breadcrumb: {
    title: "Результаты",
    to: { name: "brackets" }
  }
};
</script>
